<template>
  <div class="container-fluid m-0 p-0">
    <div>
      <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        :interval="4000"
        no-hover-pause="false"
        fade
        img-width="1024"
        img-height="480"
      >
        <b-carousel-slide
          :img-src="`${this.$request}media/${properties.mobile? this.$configs.fields.mobile_slide_1 : this.$configs.fields.slide_1}`"
        ></b-carousel-slide>
        <b-carousel-slide
          :img-src="`${this.$request}media/${properties.mobile? this.$configs.fields.mobile_slide_2 : this.$configs.fields.slide_2}`"
        ></b-carousel-slide>
        <b-carousel-slide
          :img-src="`${this.$request}media/${properties.mobile? this.$configs.fields.mobile_slide_3 : this.$configs.fields.slide_3}`"
        ></b-carousel-slide>
      </b-carousel>
    </div>
    <div class="container-fluid m-0 p-0 mt-3">
      <p class="h4 font-italic welcome-text"><b>{{ getWelcomeText() }}</b></p>
      <div class="container-fluid mt-3 text-left">
        <a href="/shop" class="h5 welcome-text font-italic">{{ $t('order') }}</a>
        <div class="container-fluid mt-3 text-left">
          <swiper
            class="overflow-hidden"
            :options="swiperOption"
            ref="orderSwiper"
            @click-slide="handleSwiperClick"
          >
            <swiper-slide  v-for="product in swiperProducts" v-bind:key="product.id">
              <img width="200" :alt="product.fields.name_en" :src="`${$request}media/${product.fields.image}`" />
              <p class="text-center width-image-size">{{product.fields['name_' + getCurrentLanguage()]}}</p>
              <p class="text-center price width-image-size">
                <span :class="+product.fields.discounted_price? 'text-del text-danger' : ''">{{Math.round(product.fields.price)}} {{ $t('amd') }}</span>
                <span v-if="+product.fields.discounted_price">{{Math.round(product.fields.discounted_price)}} {{ $t('amd') }}</span>
              </p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <ViewImage ref="viewImage" />
      <div class="container-fluid mt-3 text-left">
        <a href="/gallery" class="h5 welcome-text font-italic">{{ $t('gallery') }}</a>
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-6 col-lg-3 mt-3" @click="handleShowModal" v-for="gallery_show_on_home_page in this.$gallery_show_on_home_page" v-bind:key="gallery_show_on_home_page.id">
            <img width="300" class="img-thumbnail mx-auto d-block" alt="gallery image" :src="`${$request}media/${gallery_show_on_home_page.fields.image}`">
          </div>
        </div>
      </div>
      <div class="container mt-3 border-bottom border-5"></div>
      <div class="container-fluid m-0 p-0 mt-3">
        <iframe class="google-maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.459710857356!2d44.56638331544421!3d40.198835879391076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aa356cb4eb985%3A0x9f0c359e83df208!2sPanino!5e0!3m2!1shy!2s!4v1626237865958!5m2!1shy!2s" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import ViewImage from "./ViewImage";

export default {
  name: "HomePage",
  props: ['properties'],
  components: {
    Swiper,
    SwiperSlide,
    ViewImage
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        loop : true,
        autoplay: 1000,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
      swiperProducts: [],
      isMobile: false
    }
  },
  created() {
    let swiperProducts = []
    for(let index in this.$products) {
      if (this.$products[index].fields.special_offer){
        swiperProducts.push(this.$products[index])
      }
    }
    this.swiperProducts = swiperProducts
    setInterval(() => {
      this.$refs.orderSwiper.$swiper.slideNext(1000)
    }, 2500)
  },
  methods:{
    getWelcomeText(){
      if(this.$configs){
        return this.$configs.fields['welcome_text_'+this.$i18n.locale]
      }
    },
    getCurrentLanguage(){
      return this.$i18n.locale
    },
    handleShowModal(el) {
      this.$refs.viewImage.showModal(el.path[0].src);
    },
    handleSwiperClick(){
      window.location.href = '/shop'
    }
  }
}

</script>

<style scoped>
.welcome-text{
  color: #392A20;
}
.width-image-size{
  width: 200px;
}
.price{
  font-size: 12px;
}
.text-del{
  text-decoration: line-through;
}
.special{
  position: absolute;
  bottom: 75px;
  font-size: 12px;
  font-style: italic;
  color: #392A20;
  text-shadow: 1px 0px #5C3622;
  border: 3px dotted #FFBE0B;
}
.google-maps{
  width: 100%;
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue